/**
 * Google Analytics event tracking for AntarDristi.
 * Uses gtag() which is loaded in index.html.
 */

function gtag() {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag(...arguments);
  }
}

/** Track a page view (for SPA route changes) */
export function trackPageView(path, title) {
  gtag('event', 'page_view', {
    page_path: path,
    page_title: title || path,
  });
}

/** Track chart generation */
export function trackChartGenerated(chartName) {
  gtag('event', 'chart_generated', {
    event_category: 'Chart',
    event_label: chartName || 'unnamed',
  });
}

/** Track AI insight requested */
export function trackInsightRequested(section) {
  gtag('event', 'ai_insight_requested', {
    event_category: 'AI',
    event_label: section,
  });
}

/** Track AI insight refreshed */
export function trackInsightRefreshed(section) {
  gtag('event', 'ai_insight_refreshed', {
    event_category: 'AI',
    event_label: section,
  });
}

/** Track tab switch */
export function trackTabSwitch(tabName) {
  gtag('event', 'tab_switch', {
    event_category: 'Navigation',
    event_label: tabName,
  });
}

/** Track profile switch */
export function trackProfileSwitch(profileName) {
  gtag('event', 'profile_switch', {
    event_category: 'Chart',
    event_label: profileName,
  });
}

/** Track graha link click */
export function trackGrahaLinkClick(planet) {
  gtag('event', 'graha_link_click', {
    event_category: 'Navigation',
    event_label: planet,
  });
}
